
import React from 'react';
import PropTypes from 'prop-types';

import { IMaskInput } from 'react-imask';

export const MaskInput = React.forwardRef((props, ref) => {
  const { register, name, ...other } = props;

  return (
    <IMaskInput
      placeholderChar="_"
      overwrite
      name={name}
      {...other}
      inputRef={register.ref}
      onAccept={(_, mask) => {
        register.onChange({
          target: {
            name,
            value: mask.unmaskedValue,
          },
        });
      }}
    />
  );
});

MaskInput.propTypes = {
  name: PropTypes.string.isRequired,
  register: PropTypes.object.isRequired,
};
